// React
import React, {useEffect, useState} from "react";

// Internal
import {FormCheckbox} from "../forms/form-checkbox";
import {Modal, ModalForm} from "../modal/modal";
import {ModalButtonType, ModalWidth} from "../modal/modal-constants";

function SelectTableColumnsModal(props) {
    const [selectedColumns, setSelectedColumns] = useState([]);

    useEffect(() => {
        setSelectedColumns(props.SelectedColumns || []); // todo
    }, [props.Show]);

    const select = () => {
        props.Select(selectedColumns);
    };

    const toggleSelectedColumn = (fieldName) => {
        let newSelectedColumns = selectedColumns.slice(0);
        if (newSelectedColumns.includes(fieldName)) {
            newSelectedColumns = newSelectedColumns.filter(item => item !== fieldName);
        } else {
            newSelectedColumns.push(fieldName);
        }
        setSelectedColumns(newSelectedColumns);
    };

    const getColumns = () => {
        return props.Columns.map((column, index) => {
            if (column.Visible === undefined || column.Visible) {
                return (
                    <FormCheckbox
                        key={index}
                        Label={column.Label}
                        Data={column.FieldName}
                        Value={selectedColumns.includes(column.FieldName)}
                        OnChange={toggleSelectedColumn}/>
                );
            }
        });
    };

    const requiredFields = () => {
        return selectedColumns.length > 0;
    };

    const getFooterButtons = () => {
        return [
            {
                Label: "Select",
                Type: ModalButtonType.Primary,
                Visible: requiredFields(),
                OnClick: select
            },
            {
                Label: "Cancel",
                Type: ModalButtonType.Secondary,
                Visible: true,
                OnClick: props.Close
            }
        ]
    };

    return (
        <Modal Show={props.Show} Title="Select columns" Width={ModalWidth.Narrow} Close={props.Close} FooterButtons={getFooterButtons()}>
            <ModalForm ContainerClass={"eone-ui-select-table-columns-form-container"}>
                {getColumns()}
            </ModalForm>
        </Modal>
    )
}

export { SelectTableColumnsModal }